import { io } from 'socket.io-client';

export default () => {
  const enableDebug = false;
  const htmlElement = document.querySelector('html');
  const chatbot = document.querySelector('.js-chatbot');
  if (chatbot) {
    const domain = chatbot.getAttribute('data-domain');
    const chatbotPanel = chatbot.querySelector('.js-chatbot-panel');
    const chatbotContent = chatbot.querySelector('.js-chatbot-content');
    const chatbotClose = chatbot.querySelector('.js-chatbot-close');
    const chatbotTrigger = chatbot.querySelector('.js-chatbot-trigger');
    const input = chatbot.querySelector('.js-chatbot-input');
    const chatbotSubmit = chatbot.querySelector('.js-chatbot-submit');
    const dataPingDelay = +chatbot.getAttribute('data-ping-delay') * 60 * 1000;
    const dataDisconnectAfter =
      +chatbot.getAttribute('data-disconnect-delay') * 60 * 1000;
    const dataPingMessage = chatbot.getAttribute('data-ping-message');
    const dataWelcomeMessage = chatbot.getAttribute('data-welcome-message');
    const dataBadgeStarted = chatbot.getAttribute('data-badge-started');
    const dataBadgeStartedAt = chatbot.getAttribute('data-badge-started-at');
    const dataStartStatus = chatbot.getAttribute('data-start-status');
    let dataDelayTimeout = null;
    let disconnectInterval = null;
    const dataResponseSpeed = chatbot.getAttribute('data-response-speed');
    const socketDomain =
      domain === 'localhost' ? 'http://localhost:8001' : `${domain}:444`;
    const socket = io.connect(socketDomain);
    let messageContainer = null;
    let currentMessage = '';
    let newLineMarker = '§';
    const lang = document.documentElement.lang.substring(0, 2);
    let enableScroll = true;

    // set a session object called chatbot_options
    let liaDefaultState = {
      start_disconnect_countdown: false, // Timestamp di partenza per il conteggio della disconnessione automatica
      close: dataStartStatus === 'close', // Se true, la chatbot è chiusa
      auto_interaction_message_sent: false, // Se true, il messaggio di interazione automatica è stato già inviato
      auto_interaction_countdown: false, // Timestamp di partenza per il conteggio dell'interazione automatica
      latest_timestamp: false, // Timestamp visualizzato nell'ultimo badge della chat
      interrupt_disconnect: false, // Se true, interrompe il conteggio per la disconnessione automatica
      welcome_message_sent: false, // Se true, il messaggio di benvenuto è stato già inviato
    };
    if (!sessionStorage.getItem('lia_state')) {
      sessionStorage.setItem('lia_state', JSON.stringify(liaDefaultState));
    } else {
      let liaState = JSON.parse(sessionStorage.getItem('lia_state'));
      liaState.latest_timestamp = false;
      liaState.welcome_message_sent = false;
      liaState.auto_interaction_message_sent = false;
      liaState.interrupt_disconnect = false;
      liaState.start_disconnect_countdown = false;
      liaState.auto_interaction_countdown = false;
      sessionStorage.setItem('lia_state', JSON.stringify(liaState));
    }

    const setBadge = (message) => {
      const now = Date.now();
      let liaState = JSON.parse(sessionStorage.getItem('lia_state'));
      let latestTimestamp = liaState.latest_timestamp;

      if (latestTimestamp) {
        const differenceMinutes = (now - latestTimestamp) / (1000 * 60);
        if (differenceMinutes < 5) {
          return;
        }
      }

      const template = document.querySelector('#badge').content;
      const clone = template.cloneNode(true);
      // inject cloned template in chatbot content with message inside the innerHTML
      if (message) {
        clone.querySelector('.js-chatbot-badge').innerHTML = message;
        chatbotContent.appendChild(clone);
      }

      const timestamp = Date.now();
      liaState.latest_timestamp = timestamp;
      sessionStorage.setItem('lia_state', JSON.stringify(liaState));

      scrollTop(chatbotContent);
    };

    const scrollTop = (element) => {
      if (enableScroll) {
        element.scrollTop = element.scrollHeight;
      }
    };

    const checkLiaState = (when) => {
      if (!enableDebug) {
        return;
      }
      // console table to check the state of the chatbot
      console.log('Lia State:', when);
      console.table(JSON.parse(sessionStorage.getItem('lia_state')));
    };

    const resetAutoInteractionCountdown = () => {
      let liaState = JSON.parse(sessionStorage.getItem('lia_state'));
      liaState.auto_interaction_countdown = Date.now();
      liaState.interrupt_disconnect = true;
      sessionStorage.setItem('lia_state', JSON.stringify(liaState));
    };

    const autoInteraction = () => {
      resetAutoInteractionCountdown();
      let autoInteractionInterval = setInterval(() => {
        let liaState = JSON.parse(sessionStorage.getItem('lia_state'));
        if (
          chatbot.classList.contains('is-open') &&
          !liaState.auto_interaction_message_sent &&
          Date.now() - liaState.auto_interaction_countdown >= dataPingDelay
        ) {
          setMessage(dataPingMessage, 'bot');
          scrollTop(chatbotContent);
          liaState.auto_interaction_message_sent = true;
          liaState.start_disconnect_countdown = Date.now();
          liaState.interrupt_disconnect = false;
          sessionStorage.setItem('lia_state', JSON.stringify(liaState));
          clearInterval(autoInteractionInterval);
          checkLiaState('after auto interaction');
          startDisconnectCountdown();
        }
      }, 1000);
    };

    const startDisconnectCountdown = () => {
      let startDisconnectCountdownInterval = setInterval(() => {
        let liaState = JSON.parse(sessionStorage.getItem('lia_state'));
        if (
          chatbot.classList.contains('is-open') &&
          !liaState.interrupt_disconnect &&
          Date.now() - liaState.start_disconnect_countdown >=
            dataDisconnectAfter
        ) {
          emptyChat();
          chatbot.classList.remove('is-open');
          scrollStatus('enable');
          socket.disconnect();
          liaState.close = true;
          liaState.auto_interaction_message_sent = false;
          liaState.latest_timestamp = false;
          liaState.welcome_message_sent = false;
          liaState.start_disconnect_countdown = false;
          liaState.auto_interaction_countdown = false;
          sessionStorage.setItem('lia_state', JSON.stringify(liaState));
          checkLiaState('after start disconnect countdown');
          clearInterval(startDisconnectCountdownInterval);
        }
      }, 1000);
    };

    const sendMessage = () => {
      if (socket.id === undefined) {
        socket.connect();
      }
      // get input value
      const inputValue = input.innerText;

      // scroll content to bottom
      scrollTop(chatbotContent);

      // reset input to placeholder
      input.innerText = input.getAttribute('data-placeholder');

      // remove contenteditable to input
      input.removeAttribute('contenteditable');

      // disable submit button and input
      setInputState('disabled');

      // delete timeout if exists
      clearTimeout(dataDelayTimeout);

      setMessage(inputValue, 'user');

      const languageMap = {
        it: 'italiano',
        en: 'english',
      };

      socket.emit('chat_message', {
        language: languageMap[lang],
        message: inputValue,
      });
      setMessage(false, 'typing');
      scrollTop(chatbotContent);
      checkLiaState('after user message sent');

      autoInteraction();
    };

    const setInputState = (state) => {
      if (state === 'enabled') {
        // remove disabled from submit button and input
        chatbotSubmit.removeAttribute('disabled');
        input.removeAttribute('data-disabled');
      } else if (state === 'disabled') {
        // disable submit button and input
        chatbotSubmit.setAttribute('disabled', true);
        input.setAttribute('data-disabled', true);
      }
    };

    const setMessage = (message, type) => {
      // use template to create message
      const template = document.querySelector(`#bubble-${type}`).content;
      const clone = template.cloneNode(true);
      const bubble = clone.querySelector('.js-bubble');

      if (message !== false) {
        bubble.innerHTML = message;
      }

      const id = Math.random().toString(36).substring(2);
      bubble.setAttribute('id', id);
      chatbotContent.appendChild(bubble);

      return bubble;
    };

    const removeTyping = () => {
      // delet element with class js-is-typing
      const isTyping = chatbotContent.querySelector('.js-is-typing');
      isTyping && isTyping.remove();
    };

    const finishMessage = () => {
      if (!messageContainer) {
        // Crea un nuovo elemento messaggio se non esiste
        messageContainer = setMessage('', 'bot');
        chatbotContent.appendChild(messageContainer);
      }
      // Componenti estetiche
      // checkForLinks();
      checkForLinkPattern();
      checkForEmails();
      checkForPhoneNumbers();
      checkForBold();
      currentMessage = ''; // Reset della variabile per il prossimo messaggio
      messageContainer = null; // Reset del contenitore del messaggio
      setInputState('enabled');
      chatbotSubmit.setAttribute('disabled', true);
      scrollTop(chatbotContent);
      setCursorInInput();
      autoInteraction();
    };

    const setWelcomeMessage = () => {
      let liaState = JSON.parse(sessionStorage.getItem('lia_state'));
      if (!liaState.welcome_message_sent) {
        setTimeout(() => {
          setMessage(dataWelcomeMessage, 'bot');
        }, 500);
        liaState.welcome_message_sent = true;
        liaState.auto_interaction_countdown = Date.now();
        sessionStorage.setItem('lia_state', JSON.stringify(liaState));
        checkLiaState('after welcome message');
      }
      autoInteraction();
    };

    const emptyChat = () => {
      // select alla chatbotContent direct children with class js-bubble and remove them
      const bubbles = chatbotContent.querySelectorAll(
        '.js-bubble, .js-chatbot-badge'
      );
      bubbles &&
        bubbles.forEach((bubble) => {
          bubble.remove();
        });
    };

    // iter through the buffer from the first element to the last one. Append the first element to the messageContainer and remove it from the buffer. if the readed element is a '|', call the finishMessage function
    const renderBuffer = () => {
      let resetInterval = setInterval(() => {
        resetAutoInteractionCountdown();
      }, 500);
      let interval = setInterval(() => {
        if (buffer.length > 0) {
          const char = buffer.shift();
          if (char === newLineMarker) {
            const br = document.createElement('br');
            messageContainer.appendChild(br);
          } else {
            if (char === '|') {
              finishMessage();
              clearInterval(interval);
              clearInterval(resetInterval);
            } else {
              messageContainer.innerHTML += char;
              scrollTop(chatbotContent);
            }
          }
        }
      }, dataResponseSpeed);
    };

    const checkForLinkPattern = () => {
      const regex = /\[([^\[\]]+)]\((https?:\/\/\S+?)\)/g;

      const match = messageContainer.innerHTML.match(regex);

      match &&
        match.forEach((link) => {
          const url = link.match(/\(([^)]+)\)/)[1];
          const text = link.match(/\[([^\[\]]+)\]/)[1];

          const a = document.createElement('a');
          a.href = url;
          a.target = '_blank';
          a.innerHTML = text;

          messageContainer.innerHTML = messageContainer.innerHTML.replace(
            link,
            a.outerHTML
          );
        });
    };

    const checkForLinks = () => {
      // use a regular expression to find links in the message.the url may start with http:// or https:// and end before a space, a comma, a period or a new line
      const regex =
        /\b(?!(?:https?:\/\/)?s\.w\.org\/)(https?:\/\/\S+?)(?=<br>|[.,;?!)]?(?:\s|$))/g;

      const match = messageContainer.innerHTML.match(regex);

      match &&
        match.forEach((url) => {
          const link = document.createElement('a');
          link.href = url;
          link.target = '_blank';
          link.innerHTML = url;

          messageContainer.innerHTML = messageContainer.innerHTML.replace(
            url,
            link.outerHTML
          );
        });
    };

    const checkForEmails = () => {
      // use a regular expression to find emails in the message before a space, a comma, a period or a new line
      const regex = /\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/g;
      const match = messageContainer.innerHTML.match(regex);

      match &&
        match.forEach((email) => {
          const link = document.createElement('a');
          link.href = `mailto:${email}`;
          link.innerHTML = email;

          // replace the email with the link
          messageContainer.innerHTML = messageContainer.innerHTML.replace(
            email,
            link.outerHTML
          );
        });
    };

    const checkForBold = () => {
      // use a regular expression to find bold text in the message bewteen ** and **
      const regex = /\*\*.*?\*\*/g;
      const match = messageContainer.innerHTML.match(regex);

      match &&
        match.forEach((bold) => {
          const boldText = document.createElement('strong');
          boldText.innerHTML = bold.replace(/\*\*/g, ''); // remove the ** from the bold text

          // replace the bold text with the strong tag
          messageContainer.innerHTML = messageContainer.innerHTML.replace(
            bold,
            boldText.outerHTML
          );
        });
    };

    const checkForPhoneNumbers = () => {
      // use a regular expression to find phone numbers in the message
      // use the following types of phone numbers:
      // 051 458011, 051.458011, 051-458011, 051458011, +39 051 458011, +39 051.458011, +39 051-458011, +39 051458011
      const regex = /(\+39\s)?\d{3}(\s|\.|\-)?\d{6}/g;
      const match = messageContainer.innerHTML.match(regex);

      match &&
        match.forEach((phone) => {
          const link = document.createElement('a');
          link.href = `tel:${phone}`;
          link.innerHTML = phone;

          // replace the phone number with the link
          messageContainer.innerHTML = messageContainer.innerHTML.replace(
            phone,
            link.outerHTML
          );
        });
    };

    const checkForNewLine = () => {
      // use a regular expression to find new lines in the message
      const regex = /\n/g;
      const match = messageContainer.innerHTML.match(regex);

      match &&
        match.forEach((newLine) => {
          // replace the new line with a br tag
          messageContainer.innerHTML = messageContainer.innerHTML.replace(
            newLine,
            '<br>'
          );
        });
    };

    const scrollStatus = (status) => {
      if (window.innerWidth >= 640) {
        htmlElement.style.overflow = 'auto';
        return;
      }

      if (status === 'enable') {
        // enable scroll
        htmlElement.style.overflow = 'auto';
      } else if (status === 'disable') {
        // disable scroll when chatbot is open only under 640px
        htmlElement.style.overflow = 'hidden';
      }
    };

    const setCursorInInput = () => {
      // click on input to set the cursor inside it
      input.click();

      // set the cursor at the end of the input
      const range = document.createRange();
      const sel = window.getSelection();
      range.selectNodeContents(input);
      range.collapse(false);
      sel.removeAllRanges();
      sel.addRange(range);

      // focus the input
      input.focus();
    };

    if (
      dataStartStatus === 'open' &&
      !JSON.parse(sessionStorage.getItem('lia_state')).close &&
      window.innerWidth >= 640
    ) {
      chatbot.classList.add('is-open');
      scrollStatus('disable');
    }

    socket.on('connect', function () {
      console.log('WebSocket Connected', socket.id);
      // Call the function to start the timer only if chatbot.classList contains is-open
      if (chatbot.classList.contains('is-open')) {
        checkLiaState('on load');
        setBadge(
          `${dataBadgeStarted} ${new Date().toLocaleDateString(
            navigator.language,
            {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
            }
          )} ${dataBadgeStartedAt} ${new Date().toLocaleTimeString(
            navigator.language,
            {
              hour: '2-digit',
              minute: '2-digit',
            }
          )}`
          // 'Oggi'
        );

        // set welcome message
        setWelcomeMessage();
      }
    });

    socket.on('disconnect', function () {
      console.log('WebSocket Disconnected');
      socket.emit('clear_session'); // Pulizia dei messaggi in session. I messaggi in session sono salvati per rispondere a domande come "dimmi di più", per rendere le risposte pertinenti. Quest'ultima va però svuotata.
    });

    let buffer = [];
    socket.on('chat_response', function (msg) {
      let chunk = null;
      if (!messageContainer) {
        // create new cutom event
        const event = new CustomEvent('chatbot-response', { detail: 'start' });
        // dispatch the event
        document.dispatchEvent(event);
        // Se è il primo chunk, crea un nuovo elemento messaggio
        messageContainer = setMessage('', 'bot');
        removeTyping();
        chatbotContent.appendChild(messageContainer);
      }
      chunk = msg.data;
      // if the chunk contains one or more new lines, replace them with newLineMarker
      if (chunk.includes('\n')) {
        chunk = chunk.replace(/\n/g, newLineMarker);
      }
      chunk = chunk.split('');
      // store the msg.data in a variable as a list of characters
      buffer = [...buffer, ...chunk];
    });

    document.addEventListener('chatbot-response', (e) => {
      if (e.detail === 'start') {
        // enable scroll
        enableScroll = true;
        // start reading the buffer
        renderBuffer();
      }
    });

    // add scroll event listener  on messageContainer
    chatbotContent &&
      chatbotContent.addEventListener('wheel', () => {
        console.log('scroll');
        // if user scrolls up, disable auto scroll and remove listener
        if (
          chatbotContent.scrollTop + chatbotContent.clientHeight <
          chatbotContent.scrollHeight
        ) {
          enableScroll = false;

          // remove scroll event listener
          chatbotContent.removeEventListener('scroll', () => {});
        }
      });

    chatbotTrigger.addEventListener('click', () => {
      chatbot.classList.add('is-open');
      input.innerText = input.getAttribute('data-placeholder');
      scrollStatus('disable');
      checkLiaState('after Trigger click');
      setBadge(
        `Chat iniziata il ${new Date().toLocaleDateString(navigator.language, {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        })} alle ${new Date().toLocaleTimeString(navigator.language, {
          hour: '2-digit',
          minute: '2-digit',
        })}`
        // 'Oggi'
      );

      // set welcome message
      setWelcomeMessage();
      scrollTop(chatbotContent);
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 640) {
        // htmlElement.style.overflow = 'auto';
        scrollStatus('enable');
      } else {
        if (chatbot.classList.contains('is-open')) {
          // htmlElement.style.overflow = 'hidden';
          scrollStatus('disable');
        }
      }
    });

    chatbotClose.addEventListener('click', () => {
      chatbot.classList.remove('is-open');

      // set a session cookie to prevent chatbot to open again
      let lia_state = JSON.parse(sessionStorage.getItem('lia_state'));
      lia_state.close = true;
      sessionStorage.setItem('lia_state', JSON.stringify(lia_state));
      scrollStatus('enable');

      // reset input to placeholder
      input.innerText = input.getAttribute('data-placeholder');
    });

    // focus input on click
    input.addEventListener('click', () => {
      // if input contains data-disabled, return
      if (input.getAttribute('data-disabled')) {
        return;
      }

      // add contenteditable to input
      input.setAttribute('contenteditable', true);
      input.focus();
      // remove placeholder from input if is equal to placeholder
      if (input.innerText === input.getAttribute('data-placeholder')) {
        input.innerText = '';
      }
    });

    // detect click outside input
    document.addEventListener('click', (e) => {
      if (!input.contains(e.target)) {
        chatbot.classList.remove('is-focus');
        // remove contenteditable to input if text is empty or equal to placeholder
        if (
          !input.innerText ||
          input.innerText === input.getAttribute('data-placeholder')
        ) {
          input.removeAttribute('contenteditable');
          chatbotSubmit.setAttribute('disabled', true);
        }

        // if innerText is empty, add placeholder
        if (!input.innerText) {
          input.innerText = input.getAttribute('data-placeholder');
        }
      }
    });

    // detect if i'm typing and scroll content to bottom
    input.addEventListener('input', () => {
      if (input.innerText !== '') {
        chatbotSubmit.removeAttribute('disabled');
      }

      // prevent html, css and js injection
      input.innerText = input.innerText.replace(/<[^>]+>/g, '');

      resetAutoInteractionCountdown();

      // metti sempre il cursore alla fine del contenuto
      const range = document.createRange();
      const sel = window.getSelection();
      range.selectNodeContents(input);
      range.collapse(false);
      sel.removeAllRanges();
      sel.addRange(range);
    });

    // detect if i press enter or click on submit button and send message
    chatbotSubmit.addEventListener('click', () => {
      sendMessage();
    });

    input.addEventListener('keydown', (e) => {
      if (e.keyCode === 13 && input.innerText !== '') {
        e.preventDefault();
        sendMessage();
      }
    });

    input.addEventListener('paste', (e) => {
      // convert pasted text to plain text
      e.preventDefault();
      const text = e.clipboardData.getData('text/plain');
      document.execCommand('insertText', false, text);
    });
  }
};
